import React from 'react';
import { StyledTagNewWrapper } from '@src/containers/Layout/SidebarNew/DesktopSidebar/index.style';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { StyledTabItem } from './index.style';

const TabItem = ({
  label,
  count,
  isActive,
  onClick,
  styleTab,
  isNew,
  activeTextVariant = 'body-14-medium',
  textVariant = 'body-14-medium',
  activeTextColor = COLOR.darkGray,
  textColor = COLOR.label2[64],
}) => {
  const { t } = useTranslation();
  return (
    <StyledTabItem
      className={isActive ? 'active' : ''}
      onClick={onClick}
      styleTab={styleTab}
    >
      <Typography
        variant={isActive ? activeTextVariant : textVariant}
        color={isActive ? activeTextColor : textColor}
      >
        {t(label)} {Boolean(count) && `(${count})`}
      </Typography>
      {isNew && (
        <StyledTagNewWrapper>
          <Typography variant="body-12-medium">{t('new')}</Typography>
        </StyledTagNewWrapper>
      )}
    </StyledTabItem>
  );
};

export default TabItem;
